'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactUtils = require('../../utils/reactUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  date: _reactUtils.momentShape.isRequired,
  showWeekDivider: _propTypes2.default.bool,
  render: _propTypes2.default.func
};

var defaultProps = {
  showWeekDivider: false
};

var CalendarTableHeaderCell = function CalendarTableHeaderCell(_ref) {
  var date = _ref.date,
      showWeekDivider = _ref.showWeekDivider,
      render = _ref.render;

  var classes = (0, _classnames2.default)({
    'calendar-table__week-divider': showWeekDivider
  });
  if (render) {
    return _react2.default.createElement(
      'th',
      { className: classes },
      render({ date: date })
    );
  }
  return _react2.default.createElement(
    'th',
    { className: classes },
    _react2.default.createElement(
      'span',
      null,
      date.format('ddd')
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'span',
      { className: 'muted' },
      date.format('M/D')
    )
  );
};

CalendarTableHeaderCell.displayName = 'CalendarTableHeaderCell';
CalendarTableHeaderCell.propTypes = propTypes;
CalendarTableHeaderCell.defaultProps = defaultProps;

exports.default = CalendarTableHeaderCell;